module.exports = __webpack_public_path__ + "static/media/Politicas-de-derecho-de-Autor.ffddba6a.pdf";